export default function ToastControl({message, severity, open, onClose}) {
  let type = severity ?  `alert-${severity}` : 'border';
  let icon = null;
  if (severity === 'success') {
    icon =
      <svg xmlns="http://www.w3.org/2000/svg" className="stroke-primary-content flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>;
  }
  if (severity === 'error') {
    icon = <svg xmlns="http://www.w3.org/2000/svg" className="stroke-primary-content flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>;
  }

  if (severity === 'info') {
    type = 'alert-info';
    icon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current flex-shrink-0 w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>;
  }

  return (
    <div className={`${open ? 'visible mb-2 mt-2' : 'invisible h-0 m-0 p-0'} alert ${type} shadow-lg border`} role="alert">
      {icon}
      <span className="text-brand-text">{message}</span>
      <button type="button"
              onClick={
                onClose
              }
              className="ml-auto -mx-1.5 -my-1.5 text-brand-text rounded-lg focus:ring-2 p-1.5 hover:bg-gray-400 inline-flex h-8 w-8"
              aria-label="Close">
        <span className="sr-only">Close</span>
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"/>
        </svg>
      </button>
    </div>

  );
}
